import { lazy } from 'react';
import Loadable from 'components/Loadable';
import DefaultLayout from 'layout/Default';
import { ProtectedRoute } from 'routes/RouteGuards';

const DashboardPage = Loadable(
  lazy(() => import('views/dashboard/index'))
);

const DashboardRoutes = {
  path: '/dashboard',
  element: <ProtectedRoute />,
  children: [
    {
      element: <DefaultLayout />,
      children: [
        {
          index: true,
          element: <DashboardPage />
        }
      ]
    }
  ]
};

export default DashboardRoutes;
